import { QueryConfig } from "store/utils/query-config";

export const pipelineCardsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
